import { render, staticRenderFns } from "./SolAgoraStep4.vue?vue&type=template&id=8f443b5c&"
import script from "./SolAgoraStep4.vue?vue&type=script&lang=js&"
export * from "./SolAgoraStep4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports